export default Object.freeze({
  "CREATED": "CRE",
  "PENDING_ACT": "PAC",
  "ACTIVATED": "ACT",
  "INACTIVE": "ICT",
});

